import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "@/App";
import { Provider } from "react-redux";
import { store } from "@/shared/store";
import { initTranslations } from "./i18n";

initTranslations();

const createRootElement = (): HTMLDivElement => {
  const root = document.createElement("div");
  root.setAttribute("id", "root");
  document.body.appendChild(root);
  return root;
};

const rootElement = document.getElementById("root") ?? createRootElement();

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
